export default __webpack_public_path__ + "static/media/cardio.d9c1bee0.svg";